import React from 'react';

import { aiConfigItemMessages } from '@atlaskit/editor-common/ai-messages';
import RovoIcon from '@atlassian/generative-ai-modal/assets/RovoIcon';
import sharedMessages from '@atlassian/generative-ai-modal/utils/messages';

import {
	createInsertAtCurrentPosition,
	createInsertBelow,
	createReplace,
} from '../../actions/create-actions';
import { CONFIG_ITEM_KEYS } from '../../config-item-keys';
import type { EditorPluginAIConfigItem } from '../../config-items';

export const freeGenerate: () => EditorPluginAIConfigItem = () => {
	return {
		key: CONFIG_ITEM_KEYS.FREE_GENERATE,
		title: sharedMessages.rovoButtonTitle,
		description: sharedMessages.rovoUniversalLongCallToAction,
		promptHint: aiConfigItemMessages.freeGenerateRovoPromptHint,
		icon: () => <RovoIcon label="" size="small" />,
		doNotHighlightDocWhenSelectionIsEmpty: true,
		insertOnEmptySelection: true,
		agentId: 'editor_agent',
		canTogglePageKnowledge: true,
		quickInsertPriority: Number.NEGATIVE_INFINITY,
		intentSchemaId: 'custom_free_generate_intent_schema.json',
		featureId: 'free_generate',
		actions: {
			empty: [createInsertAtCurrentPosition({ appearance: 'primary' })],
			selection: [
				createInsertBelow({ appearance: 'secondary' }),
				createReplace({ appearance: 'primary' }),
			],
		},
		getBackendModel: () => {
			return 'assistance-service';
		},
		withContextMutation: (configItem, { latestPromptResponse }) => {
			return latestPromptResponse
				? {
						...configItem,
						intentSchemaId: 'custom_with_interrogation_intent_schema.json',
						featureId: 'interrogation',
					}
				: configItem;
		},
	};
};
